import api from "@/services/api";

type GetVehicleDocumentUrlPayload = {
	vehicleId: string;
	documentId: string;
	openUrl?: boolean;
};

type GetVehicleDocumentUrlResponse = {
	documentId: number;
	fileName: string;
	url: string;
	expiresAtUtc: string;
	hasFile: boolean;
};
export const getVehicleDocumentUrl = async (
	payload: GetVehicleDocumentUrlPayload
) => {
	const { vehicleId, documentId, openUrl } = payload;

	const { data } = await api.get<GetVehicleDocumentUrlResponse>(
		`/api/vehicles/${vehicleId}/documents/${documentId}/url`
	);

	if (openUrl) {
		// Abre a URL em uma nova aba
		window.open(data.url, "_blank");
		return;
	}

	if (data.url) {
		// Faz o download do arquivo
		const temp = await fetch(data.url);
		const blob = await temp.blob();
		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = data.fileName || "documento.pdf";
		a.rel = "noopener noreferrer";
		a.target = "_blank";
		a.style.display = "none";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
		return;
	}
};
